/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const MemoryMountAccess = {
  ReadOnly: "read_only",
  ReadWrite: "read_write",
} as const;
export type MemoryMountAccess = ClosedEnum<typeof MemoryMountAccess>;

/** @internal */
export const MemoryMountAccess$inboundSchema: z.ZodNativeEnum<
  typeof MemoryMountAccess
> = z.nativeEnum(MemoryMountAccess);
/** @internal */
export const MemoryMountAccess$outboundSchema: z.ZodNativeEnum<
  typeof MemoryMountAccess
> = MemoryMountAccess$inboundSchema;
